import { render } from "./RealizationsPage.vue?vue&type=template&id=ca9bc2c8&scoped=true"
import script from "./RealizationsPage.vue?vue&type=script&lang=js"
export * from "./RealizationsPage.vue?vue&type=script&lang=js"

import "./RealizationsPage.vue?vue&type=style&index=0&id=ca9bc2c8&lang=scss&scoped=true"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9bc2c8"]])

export default __exports__